{
  "/": {
    "alt": "audiocn: a five-channel mixer, rotary knobs and a waveform in the dark Stone theme.",
    "url": "/og/home-14a5416dabae.png"
  },
  "/contributors": {
    "alt": "audiocn contributors: a mixer and its controls, built together in the open.",
    "url": "/og/contributors-6276b4bb16ec.png"
  },
  "/docs/blocks": {
    "alt": "Blocks — audiocn: a mixer and sound pads composed into an audio console.",
    "url": "/og/blocks-ac515e4829e4.png"
  },
  "/docs/blocks/mic-setup": {
    "alt": "Microphone Setup — audiocn: microphone setup with a device selector, preview, gain and level check.",
    "url": "/og/blocks-mic-setup-d9c2769ce50f.png"
  },
  "/docs/blocks/music-player": {
    "alt": "Music Player — audiocn: a complete playlist player with waveform seeking and transport controls.",
    "url": "/og/blocks-music-player-200b8dbbecc7.png"
  },
  "/docs/blocks/quick-audio-popover": {
    "alt": "Quick Audio Popover — audiocn: an open audio popover with microphone and system audio settings.",
    "url": "/og/blocks-quick-audio-popover-b7e4032b961f.png"
  },
  "/docs/blocks/soundboard": {
    "alt": "Soundboard — audiocn: a complete soundboard with hotkeys, pads, volume and stop controls.",
    "url": "/og/blocks-soundboard-1acd117f32b4.png"
  },
  "/docs/blocks/system-audio-mixer": {
    "alt": "System Audio Mixer — audiocn: a complete system audio mixer with microphone, music, sound pads and master controls.",
    "url": "/og/blocks-system-audio-mixer-d74e5e2f8a52.png"
  },
  "/docs/blocks/system-audio-settings": {
    "alt": "System Audio Settings — audiocn: system audio settings with capture, volume and a meter.",
    "url": "/og/blocks-system-audio-settings-a5dbdd89433a.png"
  },
  "/docs/components/audio-device-select": {
    "alt": "Audio Device Select — audiocn: microphone selectors with named USB and default devices.",
    "url": "/og/components-audio-device-select-73b15dc3ef6d.png"
  },
  "/docs/components/audio-player": {
    "alt": "Audio Player — audiocn: an audio player with transport, seeking, time and volume controls.",
    "url": "/og/components-audio-player-5328fa31b40c.png"
  },
  "/docs/components/bar-visualizer": {
    "alt": "Bar Visualizer — audiocn: a frequency-band bar visualizer with an active signal.",
    "url": "/og/components-bar-visualizer-2c7aa5b2fe9d.png"
  },
  "/docs/components/channel-strip": {
    "alt": "Channel Strip — audiocn: a channel strip with a meter, fader and channel controls.",
    "url": "/og/components-channel-strip-a808cf4d09be.png"
  },
  "/docs/components/channel-toggle": {
    "alt": "Channel Toggle — audiocn: mute, solo and monitor controls with their pressed states.",
    "url": "/og/components-channel-toggle-6ad554f6e4d0.png"
  },
  "/docs/components/clip-indicator": {
    "alt": "Clip Indicator — audiocn: a latched clip light beside a level meter.",
    "url": "/og/components-clip-indicator-9ad0f6536b4a.png"
  },
  "/docs/components/db-readout": {
    "alt": "dB Readout — audiocn: decibel readouts for quiet, normal and hot signal levels.",
    "url": "/og/components-db-readout-c9e8b4303157.png"
  },
  "/docs/components/db-scale": {
    "alt": "dB Scale — audiocn: a decibel scale alongside a console fader.",
    "url": "/og/components-db-scale-87b08090f746.png"
  },
  "/docs/components/electric-bar-visualizer": {
    "alt": "Electric Bar Visualizer — audiocn: glowing frequency bars drawn as electric filaments.",
    "url": "/og/components-electric-bar-visualizer-c5fe116d9ce1.png"
  },
  "/docs/components/electric-waveform": {
    "alt": "audiocn Electric Waveform: a glowing audio trace with a bright core and branching arcs on a dark surface.",
    "url": "/og/electric-waveform-2936bc92a662.png"
  },
  "/docs/components/fader": {
    "alt": "Fader — audiocn: three console faders at different gain settings.",
    "url": "/og/components-fader-732e844cdf08.png"
  },
  "/docs/components": {
    "alt": "Components — audiocn: level meters, rotary knobs, faders and a waveform.",
    "url": "/og/components-f5c506c4d52a.png"
  },
  "/docs/components/knob": {
    "alt": "audiocn Knob: gain, pan and frequency rotary controls with value labels and range arcs.",
    "url": "/og/knob-5208933ad2d3.png"
  },
  "/docs/components/lcd-display": {
    "alt": "LCD Display — audiocn: an amber dot-matrix screen with model and effort settings.",
    "url": "/og/components-lcd-display-97c0d292d5b9.png"
  },
  "/docs/components/level-meter": {
    "alt": "audiocn Level Meter: solid and segmented stereo meters with green and yellow zones, scales and peak hold.",
    "url": "/og/level-meter-5a0d4ae19443.png"
  },
  "/docs/components/live-waveform": {
    "alt": "Live Waveform — audiocn: a live oscilloscope trace and scrolling signal history.",
    "url": "/og/components-live-waveform-f7b92ebc9c5b.png"
  },
  "/docs/components/mixer": {
    "alt": "audiocn Mixer: microphone, system audio, music, sounds and master strips with faders and active meters.",
    "url": "/og/mixer-51f748ca9f67.png"
  },
  "/docs/components/pan-control": {
    "alt": "Pan Control — audiocn: a pan slider with a centre detent and a left balance value.",
    "url": "/og/components-pan-control-2e2f167d3b45.png"
  },
  "/docs/components/parameter-slider": {
    "alt": "Parameter Slider — audiocn: frequency, Q and gain parameter sliders.",
    "url": "/og/components-parameter-slider-60f523f9aa21.png"
  },
  "/docs/components/smooth-waveform": {
    "alt": "Smooth Waveform — audiocn: a flowing audio wave and an oscilloscope line.",
    "url": "/og/components-smooth-waveform-8c93ccfafa17.png"
  },
  "/docs/components/sound-pad": {
    "alt": "Sound Pad — audiocn: sound pads with hotkeys and playback progress.",
    "url": "/og/components-sound-pad-354561ef7f59.png"
  },
  "/docs/components/spectrum": {
    "alt": "Spectrum — audiocn: a frequency spectrum with axes, grid and peak hold.",
    "url": "/og/components-spectrum-55bf80ac9d51.png"
  },
  "/docs/components/track-list": {
    "alt": "Track List — audiocn: a track list with active and playing states.",
    "url": "/og/components-track-list-f98b16d581e5.png"
  },
  "/docs/components/volume-control": {
    "alt": "Volume Control — audiocn: a volume slider with a mute control and numeric value.",
    "url": "/og/components-volume-control-fbf2c069934b.png"
  },
  "/docs/components/waveform": {
    "alt": "audiocn Waveform: an audio clip with a mirrored waveform, a playhead, a selected region and a marker.",
    "url": "/og/waveform-765f8287128f.png"
  },
  "/docs/concepts/accessibility": {
    "alt": "Accessibility — audiocn: gain, pan and frequency knobs with labelled values.",
    "url": "/og/concepts-accessibility-7b1044b87c2f.png"
  },
  "/docs/concepts/custom-engine": {
    "alt": "Using your own audio engine — audiocn: a five-channel mixer with meters, faders and mute and solo controls.",
    "url": "/og/concepts-custom-engine-a907d3711073.png"
  },
  "/docs/concepts/decibels": {
    "alt": "Decibels and levels — audiocn: solid and segmented stereo level meters with scales and peak hold.",
    "url": "/og/concepts-decibels-c2a7e04a0b86.png"
  },
  "/docs/concepts/feeding-data": {
    "alt": "Feeding data — audiocn: a frequency spectrum with axes, grid and peak hold.",
    "url": "/og/concepts-feeding-data-fbc44ae58deb.png"
  },
  "/docs/concepts/theming": {
    "alt": "Theming — audiocn: the same audio controls in light and dark themes.",
    "url": "/og/concepts-theming-0734b4546dfc.png"
  },
  "/docs/hooks/use-audio-analyser": {
    "alt": "useAudioAnalyser — audiocn: a frequency spectrum with axes, grid and peak hold.",
    "url": "/og/hooks-use-audio-analyser-d6cbdc8594e9.png"
  },
  "/docs/hooks/use-audio-context": {
    "alt": "useAudioContext — audiocn: a five-channel mixer with meters, faders and mute and solo controls.",
    "url": "/og/hooks-use-audio-context-23d60428808b.png"
  },
  "/docs/hooks/use-audio-devices": {
    "alt": "useAudioDevices — audiocn: microphone selectors with named USB and default devices.",
    "url": "/og/hooks-use-audio-devices-a82dd36d0664.png"
  },
  "/docs/hooks/use-audio-player": {
    "alt": "useAudioPlayer — audiocn: an audio player with transport, seeking, time and volume controls.",
    "url": "/og/hooks-use-audio-player-e35f27be7aaa.png"
  },
  "/docs/hooks/use-clip-hold": {
    "alt": "useClipHold — audiocn: a latched clip light beside a level meter.",
    "url": "/og/hooks-use-clip-hold-d24e3b780520.png"
  },
  "/docs/hooks/use-demo-signal": {
    "alt": "useDemoSignal — audiocn: a frequency-band bar visualizer with an active signal.",
    "url": "/og/hooks-use-demo-signal-8107aa367bf4.png"
  },
  "/docs/hooks/use-frame-source": {
    "alt": "useFrameSource — audiocn: a live oscilloscope trace and scrolling signal history.",
    "url": "/og/hooks-use-frame-source-7b059ca7601c.png"
  },
  "/docs/hooks/use-gain-node": {
    "alt": "useGainNode — audiocn: a channel strip with a meter, fader and channel controls.",
    "url": "/og/hooks-use-gain-node-6906c7ea1f57.png"
  },
  "/docs/hooks/use-level": {
    "alt": "useLevel — audiocn: solid and segmented stereo level meters with scales and peak hold.",
    "url": "/og/hooks-use-level-b0c08507afe3.png"
  },
  "/docs/hooks/use-microphone": {
    "alt": "useMicrophone — audiocn: microphone setup with a device selector, preview, gain and level check.",
    "url": "/og/hooks-use-microphone-690047915c8c.png"
  },
  "/docs/hooks/use-mixer": {
    "alt": "useMixer — audiocn: a five-channel mixer with meters, faders and mute and solo controls.",
    "url": "/og/hooks-use-mixer-fe51ee1eecef.png"
  },
  "/docs/hooks/use-reduced-motion": {
    "alt": "useReducedMotion — audiocn: a flowing audio wave and an oscilloscope line.",
    "url": "/og/hooks-use-reduced-motion-e86d13dfdca0.png"
  },
  "/docs/hooks/use-sound": {
    "alt": "useSound — audiocn: sound pads with hotkeys and playback progress.",
    "url": "/og/hooks-use-sound-b5a0f60a811a.png"
  },
  "/docs/hooks/use-system-audio": {
    "alt": "useSystemAudio — audiocn: system audio settings with capture, volume and a meter.",
    "url": "/og/hooks-use-system-audio-7755c8107c03.png"
  },
  "/docs/hooks/use-visibility": {
    "alt": "useVisibility — audiocn: a frequency-band bar visualizer with an active signal.",
    "url": "/og/hooks-use-visibility-1808a8014ad0.png"
  },
  "/docs/hooks/use-waveform-data": {
    "alt": "useWaveformData — audiocn: a mirrored waveform with a playhead, selected region and marker.",
    "url": "/og/hooks-use-waveform-data-37764ddcc86b.png"
  },
  "/docs/hooks/use-web-audio-mixer": {
    "alt": "useWebAudioMixer — audiocn: a complete system audio mixer with microphone, music, sound pads and master controls.",
    "url": "/og/hooks-use-web-audio-mixer-9ef1699399de.png"
  },
  "/docs": {
    "alt": "Introduction — audiocn: level meters, rotary knobs, faders and a waveform.",
    "url": "/og/introduction-969cc72df6c3.png"
  },
  "/docs/installation": {
    "alt": "Installation — audiocn: level meters, rotary knobs, faders and a waveform.",
    "url": "/og/installation-c3a702e1f030.png"
  }
}
